import { CSSProperties } from 'styled-components';

export const disabledSectionStyle: CSSProperties = {
  pointerEvents: 'none',
  opacity: 0.5,
};

export const theme = {
  shadow: {
    fancy: 'var(--shadow-fancy)',
    fancyRight: 'var(--shadow-fancy-right)',
    focus:
      '0 0 0 var(--shadow-focus-gap) var(--shadow-focus-bg), 0 0 0 var(--shadow-focus-width) var(--shadow-focus-color)',
    low: 'var(--shadow-low)',
    medium: 'var(--shadow-medium)',
    high: 'var(--shadow-high)',
  },
  font: {
    family: 'var(--font-family)',
    regular10: 'var(--font-regular-10)',
    regular12: 'var(--font-regular-12)',
    regular14: 'var(--font-regular-14)',
    regular16: 'var(--font-regular-16)',

    semibold10: 'var(--font-semibold-10)',
    semibold12: 'var(--font-semibold-12)',
    semibold14: 'var(--font-semibold-14)',

    bold12: 'var(--font-bold-12)',
    bold14: 'var(--font-bold-14)',
    bold16: 'var(--font-bold-16)',
    bold18: 'var(--font-bold-18)',

    heading1: 'var(--font-heading-1)',
    heading2: 'var(--font-heading-2)',
    display1: 'var(--font-display-1)',
    yuge: 'var(--font-yuge)',
  },
  color: {
    buttonIconNegative: 'var(--color-button-icon-negative)',
    buttonIconNegativeHover: 'var(--color-button-icon-negative-hover)',
    buttonIconPositive: 'var(--color-button-icon-positive)',
    buttonIconPositiveHover: 'var(--color-button-icon-positive-hover)',
    buttonPrimary: 'var(--color-button-primary)',
    buttonPrimaryHover: 'var(--color-button-primary-hover)',
    buttonSecondary: 'var(--color-button-secondary)',
    buttonSecondaryHover: 'var(--color-button-secondary-hover)',

    backgroundPrimary: 'var(--color-background-primary)',
    backgroundSecondary: 'var(--color-background-secondary)',
    backgroundLightDark: 'var(--color-background-light-dark)',
    backgroundLightDarkHover: 'var(--color-background-light-dark-hover)',
    backgroundDarkLight: 'var(--color-background-dark-light)',
    backgroundOverlay: 'var(--color-background-overlay)',

    blue5: 'var(--color-blue-5)',
    blue10: 'var(--color-blue-10)',
    blue20: 'var(--color-blue-20)',
    blue80: 'var(--color-blue-80)',
    blue100: 'var(--color-blue-100)',
    blue200: 'var(--color-blue-200)',
    blueTrans5: 'var(--color-blue-trans-5)',
    blueTrans10: 'var(--color-blue-trans-10)',
    blueTrans20: 'var(--color-blue-trans-20)',

    green5: 'var(--color-green-5)',
    green10: 'var(--color-green-10)',
    green20: 'var(--color-green-20)',
    green80: 'var(--color-green-80)',
    green100: 'var(--color-green-100)',
    green200: 'var(--color-green-200)',
    greenTrans5: 'var(--color-green-trans-5)',
    greenTrans10: 'var(--color-green-trans-10)',
    greenTrans20: 'var(--color-green-trans-20)',

    orange5: 'var(--color-orange-5)',
    orange10: 'var(--color-orange-10)',
    orange20: 'var(--color-orange-20)',
    orange80: 'var(--color-orange-80)',
    orange100: 'var(--color-orange-100)',
    orange200: 'var(--color-orange-200)',
    orangeTrans5: 'var(--color-orange-trans-5)',
    orangeTrans10: 'var(--color-orange-trans-10)',
    orangeTrans20: 'var(--color-orange-trans-20)',

    purple5: 'var(--color-purple-5)',
    purple10: 'var(--color-purple-10)',
    purple20: 'var(--color-purple-20)',
    purple40: 'var(--color-purple-40)',
    purple50: 'var(--color-purple-50)',
    purple60: 'var(--color-purple-60)',
    purple80: 'var(--color-purple-80)',
    purple90: 'var(--color-purple-90)',
    purple100: 'var(--color-purple-100)',
    purple200: 'var(--color-purple-200)',
    purple400: 'var(--color-purple-400)',
    purpleTrans5: 'var(--color-purple-trans-5)',
    purpleTrans10: 'var(--color-purple-trans-10)',
    purpleTrans20: 'var(--color-purple-trans-20)',
    purpleTrans40: 'var(--color-purple-trans-40)',
    purpleTrans50: 'var(--color-purple-trans-50)',
    purpleTrans60: 'var(--color-purple-trans-60)',
    purpleTrans80: 'var(--color-purple-trans-80)',

    indigo5: 'var(--color-indigo-5)',
    indigo10: 'var(--color-indigo-10)',
    indigo20: 'var(--color-indigo-20)',
    indigo80: 'var(--color-indigo-80)',
    indigo100: 'var(--color-indigo-100)',
    indigo200: 'var(--color-indigo-200)',
    indigo400: 'var(--color-indigo-400)',
    indigoTrans5: 'var(--color-indigo-trans-5)',
    indigoTrans10: 'var(--color-indigo-trans-10)',
    indigoTrans20: 'var(--color-indigo-trans-20)',

    red5: 'var(--color-red-5)',
    red10: 'var(--color-red-10)',
    red20: 'var(--color-red-20)',
    red80: 'var(--color-red-80)',
    red100: 'var(--color-red-100)',
    red200: 'var(--color-red-200)',
    redTrans5: 'var(--color-red-trans-5)',
    redTrans10: 'var(--color-red-trans-10)',
    redTrans20: 'var(--color-red-trans-20)',

    dark400: 'var(--color-dark-400)',
    dark500: 'var(--color-dark-500)',
    dark600: 'var(--color-dark-600)',
    dark700: 'var(--color-dark-700)',
    dark800: 'var(--color-dark-800)',

    black100: 'var(--color-black)',

    white100: 'var(--color-white-100)',
    whiteTrans5: 'var(--color-white-trans-5)',
    whiteTrans10: 'var(--color-white-trans-10)',
    whiteTrans20: 'var(--color-white-trans-20)',
    whiteTrans40: 'var(--color-white-trans-40)',
    whiteTrans50: 'var(--color-white-trans-50)',
    whiteTrans60: 'var(--color-white-trans-60)',
    whiteTrans80: 'var(--color-white-trans-80)',

    violet100: 'var(--color-violet-100)',

    teal5: 'var(--color-teal-5)',
    teal10: 'var(--color-teal-10)',
    teal20: 'var(--color-teal-20)',
    teal80: 'var(--color-teal-80)',
    teal100: 'var(--color-teal-100)',
    teal200: 'var(--color-teal-200)',
    tealTrans10: 'var(--color-teal-trans-10)',
    tealTrans20: 'var(--color-teal-trans-20)',

    textPrimary: 'var(--color-text-primary)',
    textSecondary: 'var(--color-text-secondary)',
    textBullet: 'var(--color-text-bullet)',
    textHelper: 'var(--color-text-helper)',
    textLink: 'var(--color-text-link)',
    textNegative: 'var(--color-text-negative)',

    uiTrans3: 'var(--color-ui-trans-3)',
    uiTrans5: 'var(--color-ui-trans-5)',
    uiTrans10: 'var(--color-ui-trans-10)',
    uiTrans20: 'var(--color-ui-trans-20)',
    uiTrans40: 'var(--color-ui-trans-40)',
    uiTrans50: 'var(--color-ui-trans-50)',
    uiTrans60: 'var(--color-ui-trans-60)',
    uiTrans80: 'var(--color-ui-trans-80)',

    border5: 'var(--color-border-5)',
    border10: 'var(--color-border-10)',
    border20: 'var(--color-border-20)',
    border100: 'var(--color-border-100)',
    elementBlue100: 'var(--color-element-blue-100)',
    elementBlue200: 'var(--color-element-blue-200)',
    elementGreen100: 'var(--color-element-green-100)',
    elementGreen200: 'var(--color-element-green-200)',
    elementIndigo100: 'var(--color-element-indigo-100)',
    elementIndigo200: 'var(--color-element-indigo-200)',
    elementOrange100: 'var(--color-element-orange-100)',
    elementOrange200: 'var(--color-element-orange-200)',
    elementPurple100: 'var(--color-element-purple-100)',
    elementPurple50: 'var(--color-element-purple-50)',
    elementPurple60: 'var(--color-element-purple-60)',
    elementPurple80: 'var(--color-element-purple-80)',
    elementPurpleInvert: 'var(--color-element-purple-invert)',
    elementRed100: 'var(--color-element-red-100)',
    elementRed200: 'var(--color-element-red-200)',
    elementTeal10: 'var(--color-element-teal-10)',
    elementTeal100: 'var(--color-element-teal-100)',
    elementTeal200: 'var(--color-element-teal-200)',
    elementWhiteInvert: 'var(--color-element-white-invert)',

    interactiveElementNeutral: 'var(--color-interactive-element-neutral)',
    interactiveElementSelected: 'var(--color-interactive-element-selected)',

    inherit: 'inherit',

    // Legacy/junk?
    blueFb100: 'var(--color-blue-fb-100)',
    blueFb200: 'var(--color-blue-fb-200)',
    blueLi100: 'var(--color-blue-li-100)',
    blueLi200: 'var(--color-blue-li-200)',
    careerLabel: 'var(--color-career-labels)',
    yellow100: 'var(--color-yellow-100)',
    error: 'var(--color-error)',
  },
  base: {
    height: 'var(--base-element-height)',
  },
  icon: {
    color: 'var(--icon-color)',
  },
  space: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    16: '4rem',
  },
  form: {
    radio: {
      bg: {
        hover: 'var(--form-radio-bg-hover)',
      },
    },
    option: {
      color: 'var(--form-option-color)',
      colorFocus: 'var(--form-option-color-focus, var(--form-option-color))',
      colorHover: 'var(--form-option-color-hover)',
      bg: {
        color: 'var(--form-option-bg-color)',
        colorFocus: 'var(--form-option-bg-color-focus, var(--form-option-bg-color))',
      },
    },
    icon: {
      color: 'var(--form-icon-color)',
      colorFocus: 'var(--form-icon-color-focus, var(--form-icon-color))',
      colorHover: 'var(--form-icon-color-hover)',
    },
    label: {
      color: 'var(--form-label-color)',
      icon: {
        color: 'var(--form-label-icon-color)',
        colorHover: 'var(--form-label-icon-color-hover)',
      },
    },
    value: {
      color: 'var(--form-value-color)',
      colorFocus: 'var(--form-value-color-focus, var(--form-value-color))',
      multi: {
        color: 'var(--form-value-multi-color)',
        colorHover: 'var(--form-value-multi-color-hover)',
        bg: {
          color: 'var(--form-value-multi-bg-color)',
          colorHover: 'var(--form-value-multi-bg-color-hover)',
        },
        border: {
          color: 'var(--form-value-multi-border-color)',
          colorHover: 'var(--form-value-multi-border-color-hover)',
        },
      },
    },
    placeholder: {
      color: 'var(--form-placeholder-color)',
      colorFocus: 'var(--form-placeholder-color-focus, var(--form-placeholder-color))',
    },
    border: {
      width: 'var(--form-border-width)',
      radius: 'var(--form-border-radius)',
      color: 'var(--form-border-color)',
      colorFocus: 'var(--form-border-color-focus, var(--form-border-color))',
    },
    bg: {
      color: 'var(--form-bg-color)',
      colorHover: 'var(--form-bg-hover)',
      colorFocus: 'var(--form-bg-focus)',
    },
  },
  custom: {
    heading2Color: 'var(--custom-heading2-color)',
    heading3Color: 'var(--custom-heading3-color)',
    heading4Color: 'var(--custom-heading4-color)',
    contentColor: 'var(--custom-content-color)',
  },
  mediaBreakpoint: {
    sm: '@media (max-width: 599px)',
    md: '@media (min-width: 600px)',
    lg: '@media (min-width: 960px)',
    xl: '@media (min-width: 1280px)',
  },
  scrollbarStyling: {
    scrollbarWidth: 'thin',
    scrollbarColor: 'var(--color-border-20) transparent',
  },
} as const;

export type Color = keyof typeof theme.color;
export type Font = keyof typeof theme.font;
export type Shadow = keyof typeof theme.shadow;
export type Spacing = keyof typeof theme.space;

export const fontKeys = Object.keys(theme.font) as Font[];
export const colorKeys = Object.keys(theme.color) as Color[];
export const spaceKeys = Object.keys(theme.space).map(Number) as Spacing[];

export const scrollbarStyle = {
  '&, *': {
    scrollbarWidth: 'thin' as CSSProperties['scrollbarWidth'],
    scrollbarColor: `${theme.color.border20} transparent`,
  },
};
